<div class="grid">
  @if (showWorkbookLink) {
    <div class="col-12">
      <button pButton  (click)="navigateToWorkbook()"
        style="margin-top:17px; margin-left: 5px; height:30px; width:145px; float:right; vertical-align:bottom;">
        <i pButtonIcon class="fa fa-book"></i>
        <span pButtonLabel>Workbook</span>
      </button>
      <button pButton (click)="downloadJobExport()"
        style="margin-top:17px; margin-left: 5px; height:30px; width:145px; float:right; vertical-align:bottom;">
        <i pButtonIcon class="fa fa-download"></i>
        <span pButtonLabel>Job Data</span>
      </button>
      <button pButton (click)="downloadJobSummaryExport()"
        style="margin-top:17px; margin-left: 5px; height:30px; width:145px; float:right; vertical-align:bottom;">
        <i pButtonIcon class="fa fa-download"></i>
        <span pButtonLabel>Job Summary</span>
      </button>
    </div>
  }
  <div class="col-12 mt-1">
    <p-accordion [multiple]="true" [value]="[0]">
      <p-accordion-panel [value]="0">
        <p-accordion-header>Job Site Details</p-accordion-header>
        <p-accordion-content>
          <app-job-details [(ngModel)]="job" [modelInvalid]="modelInvalid" [disabled]="disabled"></app-job-details>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel [value]="1">
        <p-accordion-header>Well Information</p-accordion-header>
        <p-accordion-content>
          <app-job-well-information [(ngModel)]="job" [modelInvalid]="modelInvalid" [disabled]="disabled"></app-job-well-information>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel [value]="2">
        <p-accordion-header>Fluid Information</p-accordion-header>
        <p-accordion-content>
          <app-job-fluid-information [(ngModel)]="job" [modelInvalid]="modelInvalid" [disabled]="disabled"></app-job-fluid-information>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel [value]="3">
        <p-accordion-header>Performance Summary</p-accordion-header>
        <p-accordion-content>
          <app-job-performance-summary [(ngModel)]="job"></app-job-performance-summary>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel [value]="4">
        <p-accordion-header>Fluid Summary</p-accordion-header>
        <p-accordion-content>
          <app-job-fluid-summary [(ngModel)]="job"></app-job-fluid-summary>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>

